"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCreateGenericOrderItemsFromCart = void 0;
const mapCreateGenericOrderItemsFromCart = (cartItems) => cartItems.map((cartItem) => ({
    sku: cartItem.id,
    quantity: cartItem.quantity,
    prices: {
        price: parseFloat(cartItem.price),
        discountPrice: parseFloat(cartItem.discountPrice),
        totalPrice: parseFloat(cartItem.discountPrice) * cartItem.quantity,
    },
    name: cartItem.name,
    images: cartItem.image ? [cartItem.image] : [],
}));
exports.mapCreateGenericOrderItemsFromCart = mapCreateGenericOrderItemsFromCart;
